import { useDispatch } from 'react-redux';
import { AppDispatchType } from '#components/redux/types';

const useAppDispatch = useDispatch.withTypes<AppDispatchType>();

export { useAppDispatch };
